import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Body from './Body';
import JelajahiSeal from './JelajahiSeal';
import JelajahiM6 from './JelajahiM6';
import JelajahiDolphin from './JelajahiDolphin';
import JelajahiAtto from './JelajahiAtto';
import TentangBYD from './TentangBYD';
import Contact from './Contact';
import Pricing from './Pricing';
import FixedIcons from './FixedIcons';
import JelajahiSealion from './JelajahiSealion';
import Blog from './Blog';
import BlogDetail from './BlogDetail';
import JelajahiDenza from './JelajahiDenza';
import { Typography } from '@mui/material';
import Seagull from './Seo/Seagull';
import JelajahiSeagull from './JelajahiSeagull';
import WarnaSeagull from './Seo/WarnaSeagull';
import InteriorSeagull from './Seo/InteriorSeagull';
import ExteriorSeagull from './Seo/ExteriorSeagull';
import FiturSeagull from './Seo/FiturSeagull';
import DenzaD9 from './Seo/DenzaD9';
import Sealion7 from './Seo/Sealion7';
import Gallery from './Gallery';
import JelajahiZ9GT from './JelajahiZ9GT';
import JelajahiM6DM from './JelajahiM6DM';
import FiturB5 from './Seo/FiturB5';
import Warranty from './Warranty';
import Atto1Junius from './Seo/Atto1Junius';
import HargaAtto1Junius from './Seo/HargaAtto1Junius';
import DenzaD9Detail from './Seo/DenzaD9Detail';
import M6Detail from './Seo/M6Detail';
import Atto3AdvancedPlusDetail from './Seo/Atto3AdvancedPlusDetail';
import Sealion7Detail from './Seo/Sealion7Detail';
import M6DMDetail from './Seo/M6DMDetail';
import HargaM6DMDetail from './Seo/HargaM6DMDetail';
import PerubahanAtto1Detail from './Seo/PerubahanAtto1Detail';
import Fleet from './Fleet';
import FleetCampaignBanner from './FleetCampaignBanner';
import { useEffect } from 'react';
import { initLeadTracking } from './analytics';

// Google Ads conversion + GA4 generate_lead untuk semua klik link WhatsApp.
function LeadTracking() {
  useEffect(() => initLeadTracking(), []);
  return null;
}

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true, // Opt-in to state transition wrapping
        v7_relativeSplatPath: true, // Opt-in to new relative splat path resolution
      }}
    >
      <LeadTracking />
      <Header />
      <Routes>
        <Route path='/' element={<Body />} />
        <Route path='/jelajahi-seal' element={<JelajahiSeal />} />
        <Route path='/jelajahi-atto' element={<JelajahiAtto />} />
        <Route path='/jelajahi-dolphin' element={<JelajahiDolphin />} />
        <Route path='/jelajahi-m6' element={<JelajahiM6 />} />
        <Route path='/jelajahi-m6-dm' element={<JelajahiM6DM />} />
        <Route path='/jelajahi-denzad9' element={<JelajahiDenza />} />
        <Route path='/jelajahi-sealion-7' element={<JelajahiSealion />} />
        <Route path='/jelajahi-atto1' element={<JelajahiSeagull />} />
        <Route path='/jelajahi-z9gt' element={<JelajahiZ9GT />} />
        <Route
          path='/jelajahi-b5'
          element={<Navigate to='/jelajahi-z9gt' replace />}
        />
        <Route path='/about-byd' element={<TentangBYD />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/fleet' element={<Fleet />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/warranty' element={<Warranty />} />
        <Route
          path='/blog/peluncuran-byd-seagull-indonesia'
          element={<Navigate to='/blog/peluncuran-byd-atto1-indonesia' replace />}
        />
        <Route
          path='/blog/peluncuran-byd-atto1-indonesia'
          element={<Seagull />}
        />
        <Route
          path='/blog/atto-3-suv-listrik-stylish'
          element={<Atto3AdvancedPlusDetail />}
        />
        <Route
          path='/blog/sealion-7-suv-listrik-sporty'
          element={<Sealion7Detail />}
        />
        <Route
          path='/blog/byd-m6-mpv-listrik-keluarga'
          element={<M6Detail />}
        />
        <Route path='/blog/byd-m6-dm-indonesia' element={<M6DMDetail />} />
        <Route
          path='/blog/harga-byd-m6-dm-bsd-serpong'
          element={<HargaM6DMDetail />}
        />
        <Route
          path='/blog/perubahan-fitur-byd-atto-1-nik-2026'
          element={<PerubahanAtto1Detail />}
        />
        <Route
          path='/blog/promo-giias-byd-2026'
          element={<Navigate to='/fleet' replace />}
        />
        <Route
          path='/blog/promo-giias-2026-byd'
          element={<Navigate to='/fleet' replace />}
        />
        <Route
          path='/blog/pilihan-warna-byd-seagull'
          element={<Navigate to='/blog/pilihan-warna-byd-atto1' replace />}
        />
        <Route
          path='/blog/pilihan-warna-byd-atto1'
          element={<WarnaSeagull />}
        />
        <Route
          path='/blog/eksterior-byd-seagull'
          element={<Navigate to='/blog/eksterior-byd-atto1' replace />}
        />
        <Route
          path='/blog/eksterior-byd-atto1'
          element={<ExteriorSeagull />}
        />
        <Route
          path='/blog/interior-byd-seagull'
          element={<Navigate to='/blog/interior-byd-atto1' replace />}
        />
        <Route
          path='/blog/interior-byd-atto1'
          element={<InteriorSeagull />}
        />
        <Route
          path='/blog/fitur-byd-seagull'
          element={<Navigate to='/blog/fitur-byd-atto1' replace />}
        />
        <Route path='/blog/fitur-byd-atto1' element={<FiturSeagull />} />
        <Route
          path='/blog/denza-d9'
          element={<Navigate to='/blog/byd-denzad9-indonesia' replace />}
        />
        <Route path='/blog/sealion-7' element={<Sealion7 />} />
        <Route
          path='/blog/denza-d9-indonesia-mpv-mewah'
          element={<DenzaD9Detail />}
        />
        <Route
          path='/blog/byd-atto-1-bsd-serpong-junius'
          element={<Atto1Junius />}
        />
        <Route
          path='/blog/harga-byd-atto-1-bsd-serpong-junius'
          element={<HargaAtto1Junius />}
        />
        <Route
          path='/blog/byd-denzaD9-indonesia'
          element={<Navigate to='/blog/byd-denzad9-indonesia' replace />}
        />
        <Route path='/blog/byd-denzad9-indonesia' element={<DenzaD9 />} />
        <Route path='/blog/fitur-denza-b5' element={<FiturB5 />} />
        <Route path='/blog/:slug' element={<BlogDetail />} />
        <Route
          path='*'
          element={
            <Typography variant='h4' textAlign='center'>
              404 - Page Not Found
            </Typography>
          }
        />
      </Routes>
      <FleetCampaignBanner />
      <Footer />
      <FixedIcons />
    </BrowserRouter>
  );
}

export default App;
